import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import polyfillCSS from 'lib/polyfills/CSS.js';
import './error-tracking.js';
import scopeLogger from './lib/scope-logger.js';
import * as hooks from './hooks';

polyfillCSS(window);

window.InteractiveExtension = window.InteractiveExtension || {};

window.Megogo = window.Megogo || {};
window.Megogo.scopeLogger = scopeLogger;
window.Megogo.interactive = {
  info(){
    const _info = [
      `Version ${import.meta.env.VITE_APP_VERSION}-${import.meta.env.VITE_TARGET_PLATFORM}`,
      `Build on ${import.meta.env.VITE_BUILD_LABEL} at ${import.meta.env.VITE_BUILD_DATE}.`,
      `Changelog: ${window.__change_log__.href}`,
      // `Bridge: ${actions.version}`,
    ];
    console.groupCollapsed('%cMegogo interactive.', 'background-color: black; color: #00B3B3; size: 1.2em; padding: 0.3em 2em; font-weight: bold;');
    console.info(_info.join('\n'));
    console.groupEnd();
  },
  hooks,
};

/*
if (process.env.NODE_ENV === 'development') {
  window.Megogo.interactive.API.debug = true;
}
*/
// window.Megogo.interactive.API.debug = true;
